<template>
  <div class="clearfix">
    <div class="sel-header clearfix">
      <sale-header ref="saleHeader" @setSaleMan="setSaleMan"></sale-header>
    </div>
    <div class="add-box clearfix" style="margin-top: 10px">
      <vxe-table
        keep-source
        show-overflow
        class="table-style"
        :auto-resize="true"
        ref="infotabel"
        :edit-rules="validRules"
        :data="formData"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column title="关联托运人订单" width="15%" v-if="type === 2">
          <template v-slot="{ row }">
            <vxe-input v-model="row.buyerOrdersId" disabled></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="关联托运人订单" width="15%" v-else>
          <template v-slot="{ row }">
            <a class="sel-link" @click="openOrder" target="_black">{{
              row.buyerOrdersId === null || row.buyerOrdersId === ""
                ? "选择关联的托运人订单"
                : row.buyerOrdersId
            }}</a>
          </template>
        </vxe-table-column>
        <vxe-table-column title="关联合同" width="15%">
          <template v-slot="{ row }">
            <div class="link-text">
              <span
                v-if="row.contractNum == null || row.contractNum == ''"
                @click="openContract"
              >
                请选择关联合同
              </span>
              <span v-else>
                {{ row.contractNum }}
              </span>
              <span class="link-other">
                <Icon type="ios-link" @click="openContract" />
              </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractBusType" width="10%" title="业务类别">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.contractBusType"
              placeholder="请选择"
              :options="contractListType"
              @change="changeContractType"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractTitle" width="20%" title="订单标题">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.contractTitle"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerName" width="20%" title="托运人名称">
          <template v-slot="{ row }">
            <platform-corp
              :row="row"
              :field="'buyerName'"
              :placeholder="'请选择平台企业'"
              @blur="clearValidate('infotabel')"
            ></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column field="sellerName" width="20%" title="承运人名称">
          <template v-slot="{ row }">
            <a class="sel-link" @click="openUser" target="_black">{{
              row.sellerName === null || row.sellerName === ""
                ? "请选择账户"
                : row.sellerName
            }}</a>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="create-order-tabel-header">
        <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="copyEvent"
        ></table-header>
      </div>
      <vxe-table
        show-overflow
        keep-source
        ref="xTable"
        class="table-style"
        max-height="320"
        :auto-resize="true"
        :edit-rules="goodsValidRules"
        :data="goodsArr"
        :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column
          width="50"
          align="center"
          type="checkbox"
        ></vxe-table-column>

        <vxe-table-column
          width="60"
          align="center"
          type="seq"
          title="序号"
        ></vxe-table-column>
        <vxe-table-column
          width="150"
          field="fileList"
          title="上传附件"
          align="center"
        >
          <template v-slot="{ row }">
            <upload-list
              :row="row"
              :initFileList="row.fileList"
              ref="uploadlistbox"
              :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
        <vxe-table-column field="addTime" title="签约日期" width="130">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.addTime"
              placeholder="选择日期"
              @change="clearValidate('xTable')"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsType" title="货物类型" width="140">
          <template v-slot="scope">
            <vxe-select
              v-model="scope.row.goodsType"
              placeholder="请选择"
              :options="goodsTypeOptions"
              @change="clearValidate('xTable')"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="140">
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.goodsName"
              :placeholder="scope.row.isNeeded"
              @input="$refs.xTable.updateStatus(scope)"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rule" title="规格" width="80">
          <template v-slot="{ row }">
            <vxe-input v-model="row.rule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column title="包装形式" width="100">
          <template v-slot="{ row }">
            <vxe-input v-model="row.packUnit" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="unit" title="单位" width="70">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.unit"
              placeholder="请选择"
              :options="unitTypeOptions"
              @change="clearValidate('xTable')"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="80">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.counts"
              :placeholder="row.isNeeded"
              v-on:input="countAllAmount($rowIndex)"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="price" title="单价" width="80">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input
              v-model="row.price"
              min="0"
              v-on:input="countAllAmount($rowIndex)"
              :placeholder="row.priceType === 1 ? '必填' : '选填'"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" title="总金额" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.amount"
              :placeholder="
                row.priceType === 2 || row.priceType === 3 ? '必填' : '选填'
              "
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerAmount" title="托运人金额" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.buyerAmount"
              :placeholder="formData[0].contractBusType === 2 ? '必填' : '选填'"
              type="float"
              digits="2"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="priceType" title="计费方式" width="90">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.priceType"
              placeholder="请选择"
              :options="priceType"
              @change="clearValidate('xTable')"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="是否含税" width="90">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.isTax"
              placeholder="请选择"
              :options="taxType"
              @change="clearValidate('xTable')"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="110">
          <template v-slot="{ row, $rowIndex }">
            <a
              class="sel-link"
              @click="
                openCarShip(
                  { i: $rowIndex, data: goodsArr },
                  formData[0].contractBusType
                )
              "
              target="_black"
              >{{
                row.carShipNum === null || row.carShipNum === ""
                  ? "请选择车船"
                  : row.carShipNum
              }}</a
            >
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="beginPlaceArea" title="起运地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="formData[0].contractBusType !== 2"
              v-model="row.beginPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="province" title="起运地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.province"
              :options="cityData"
              @change="loadCity(row.province, $rowIndex, 1)"
              @focus="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="city" title="起运地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.city"
              :options="row.cityOptions"
              @change="loadArea(row.province, row.city, $rowIndex, 1)"
              @focus="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="area" title="起运地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.area"
              :options="row.areaOptions"
              @focus="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="beginPlaceAddress"
          title="详细地址"
          width="160"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginPlaceAddress"
              placeholder="起运地"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="160">
          <!-- <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginTime"
              :placeholder="row.isNeeded"
            ></vxe-input>
          </template> -->
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.beginTime"
              placeholder="选择日期"
              @change="clearValidate('xTable')"
              :type="formData[0].contractBusType === 1 ? 'date' : 'datetime'"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="endPlaceArea" title="到达地" width="200">
          <template v-slot="{ row }">
            <Cascader
              :data="cityData"
              :load-data="loadData"
              :disabled="formData[0].contractBusType !== 2"
              v-model="row.endPlaceArea"
              transfer
            ></Cascader>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="endProvince" title="到达地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.endProvince"
              :options="cityData"
              @change="loadCity(row.endProvince, $rowIndex, 2)"
              @blur="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endCity" title="到达地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.endCity"
              :options="row.endCityOptions"
              @change="loadArea(row.endProvince, row.endCity, $rowIndex, 2)"
              @blur="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endArea" title="到达地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
              v-model="row.endArea"
              :options="row.endAreaOptions"
              @blur="clearValidate('xTable')"
              :disabled="formData[0].contractBusType !== 2"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlaceAddress" title="详细地址" width="160">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endPlaceAddress"
              placeholder="到达地"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="160">
          <!-- <template v-slot="{ row }">
            <vxe-input
              v-model="row.endTime"
              :placeholder="row.isNeeded"
            ></vxe-input>
          </template> -->
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endTime"
              placeholder="选择日期"
              @change="clearValidate('xTable')"
              :type="formData[0].contractBusType === 1 ? 'date' : 'datetime'"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverName" title="司机" width="140">
          <template v-slot="{ row, $rowIndex }">
            <a
              class="sel-link"
              @click="openDriver($rowIndex)"
              target="_black"
              v-if="isShowDriver"
              >{{
                row.driverName === null || row.driverName === ""
                  ? "请选择司机"
                  : row.driverName
              }}</a
            >
            <span v-else class="no-disabled"></span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverPhone" title="手机号" width="120">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.driverPhone"
              readonly
              :disabled="!isShowDriver"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="isNeedContractImg"
          title="生成电子合同"
          width="100"
        >
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.isNeedContractImg"
              @change="changeNeedContractImg(row, $rowIndex)"
              placeholder="请选择"
              :options="taxType"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column title="收款人" width="100" field="collectionName">
          <template v-slot="{ row, $rowIndex }">
            <vxe-pulldown
              :ref="'collectionName' + $rowIndex"
              class="collection-name"
              transfer
            >
              <template>
                <vxe-input
                  v-model="row.collectionName"
                  placeholder="选填"
                  @focus="focusEvent('collectionName' + $rowIndex)"
                >
                </vxe-input>
              </template>
              <template v-slot:dropdown>
                <sel-bank-account
                  :keyWord="row.collectionName"
                  :rowIndex="$rowIndex"
                  @bankAccount="getBankAccount"
                ></sel-bank-account>
              </template>
            </vxe-pulldown>
          </template>
        </vxe-table-column>
        <vxe-table-column title="开户行" width="150" field="collectionBank">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.collectionBank"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          title="银行账户"
          width="200"
          field="collectionAccount"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.collectionAccount"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="prepayment"
          title="定金"
          width="100"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.prepayment"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="demurrageAmount"
          title="滞期费"
          width="100"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.demurrageAmount"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="loadDay"
          title="装卸天数"
          width="100"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.loadDay"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="payWay"
          title="付款方式"
          width="100"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.payWay"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliveryWay"
          title="计量及交接方式"
          width="130"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.deliveryWay"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specificClauseExtra"
          title="特别约定"
          width="150"
          v-if="isShowMoreFlied"
        >
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.specificClauseExtra"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ifGenerate" title="生成物流及结算" width="120">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
              v-model="row.ifGenerate"
              @change="changeGenerate(row, $rowIndex)"
              placeholder="请选择"
              :options="taxType"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流单号" width="150">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.logisticsNum"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120">
          <template v-slot="scope">
            <vxe-select
              v-model="scope.row.isTop"
              placeholder="请选择"
              :options="isTopTypeOptions"
              @change="clearValidate('xTable')"
              transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsCounts" title="装货数量" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.goodsCounts"
              :placeholder="row.isGenerateNeeded"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.realCount"
              :placeholder="row.isGenerateNeeded"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNote" title="物流备注" width="150">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.logisticsNote"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiveGoodsTime" title="结算时间" width="120">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.receiveGoodsTime"
              placeholder="选择日期"
              @change="clearValidate('xTable')"
              type="date"
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="settleAmount" title="结算金额" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.settleAmount"
              :placeholder="row.isGenerateNeeded"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiveGoodsNote" title="结算摘要" width="150">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.receiveGoodsNote"
              placeholder="选填"
              @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="add-btn-box">
        <Button @click="importGoods()">导入明细</Button>
        <Button @click="fullValidEvent(1)" v-if="type === 0">继续新建</Button>
        <Button status="primary" @click="fullValidEvent(0)">提交</Button>
      </div>
    </div>
    <vxe-modal
      v-model="isShowImportGoods"
      title="导入明细"
      width="600"
      height="300"
      resize
    >
      <div class="import-goods-box clearfix">
        <a class="import-goods-link" @click="impotEvent"
          ><Icon type="md-attach" />选择导入文件</a
        >
        <a
          class="import-goods-down"
          @click.stop="downloadFile('/file/0609订单明细导入模板.xls')"
          >下载模板</a
        >
      </div>
    </vxe-modal>
    <vxe-modal
      v-model="isShowModal"
      title="选择账户"
      width="800"
      height="600"
      resize
    >
      <account-modal @choose="chooseUser" ref="userModel"></account-modal>
    </vxe-modal>
    <vxe-modal
      v-model="driverModal"
      title="选择司机"
      width="800"
      height="600"
      resize
    >
      <driver-modal @choose="chooseDriver" ref="driverModel"></driver-modal>
    </vxe-modal>
    <vxe-modal
      v-model="contractVisible"
      title="选择合同"
      width="1300"
      height="700"
      resize
      remember
    >
      <contract-modal
        @choose="chooseContract"
        ref="contractModel"
      ></contract-modal>
    </vxe-modal>
    <vxe-modal
      v-model="orderVisible"
      title="选择订单"
      width="1300"
      height="610"
      resize
    >
      <order-modal @choose="chooseOrder" ref="orderModel"></order-modal>
    </vxe-modal>
    <vxe-modal
      v-model="carShipVisible"
      title="选择车船"
      width="1300"
      height="600"
      resize
      remember
    >
      <choose-car-ship
        ref="carShipModal"
        @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
    <div class="show-pic" v-if="isShowPicBox">
      <picture-viewer
        v-if="lookImageData && lookImageData.length > 0"
        :imgData="lookImageData"
        :picIndex="showPicIndex"
        @close="isShowPicBox = false"
      ></picture-viewer>
    </div>
  </div>
</template>

<script>
import LogoVue from "../common/Logo.vue";

import $C from "@/consts/index";
import $api from "@/apiProvider";
import auth from "@/utils/auth";
import AccountModal from "@/components/modal/Account"; // 选择账户弹窗
import DriverModal from "@/components/modal/ChooseDriver"; // 选择司机弹窗
import ContractModal from "@/components/modal/ChooseContract"; //选择合同
import OrderModal from "@/components/modal/ChooseOrder"; //选择订单
import ChooseCarShip from "@/components/modal/ChooseCarShip";
import PictureViewer from "@/components/common/PictureViewer";
import { contractbusMap, taxMap } from "@/filters/type";
import { timeFormatDate, timeToVal } from "@/filters/time";
import {
  showLoading,
  hideLoading,
  isEmpty,
  isNotEmpty,
  getExcelTime,
  showFailMsgList
} from "@/utils/util";
import PlatformCorp from "@/components/common/PlatformCorp";
import SaleHeader from "@/components/common/SaleHeader"; // 顶部选择框
import TableHeader from "@/components/common/TableHeader";
import UploadList from "@/components/common/UploadList";
import SelBankAccount from "@/components/modal/SelBankAccount";
import moment from "moment";
import XLSX from "xlsx";
const assign = o => Object.assign({}, o);
const empties = [undefined, "", null, "null", {}, []];
var appData = require("@/assets/json/zz.json");

export default {
  props: {
    type: Number,
    rowInfo: Object,
    isShowAddModal: Boolean
  },
  components: {
    AccountModal,
    ContractModal,
    OrderModal,
    ChooseCarShip,
    PictureViewer,
    PlatformCorp,
    SaleHeader,
    TableHeader,
    UploadList,
    DriverModal,
    SelBankAccount
  },
  data() {
    return {
      validRules: {
        contractBusType: [{ required: true, message: "请选择业务类别" }],
        buyerName: [{ required: true, message: "请选择托运人名称" }],
        sellerName: [{ required: true, message: "请选择承运人名称" }]
      },
      goodsValidRules: {
        goodsName: [{ validator: this.requireValid }],
        goodsType: [{ validator: this.requireValid }],
        unit: [{ validator: this.requireValid }],
        counts: [{ validator: this.requireValid }],
        priceType: [{ validator: this.requireValid }],
        isTax: [{ validator: this.requireValid }],
        carShipNum: [{ validator: this.requireValid }],
        beginPlaceAddress: [{ validator: this.requireValid }],
        endPlaceAddress: [{ validator: this.requireValid }],
        // beginPlaceArea: [{ validator: this.requireValid }],
        // endPlaceArea: [{ validator: this.requireValid }],
        province: [{ validator: this.requireValid }],
        city: [{ validator: this.requireValid }],
        area: [{ validator: this.requireValid }],
        endProvince: [{ validator: this.requireValid }],
        endCity: [{ validator: this.requireValid }],
        endArea: [{ validator: this.requireValid }],
        beginTime: [{ validator: this.requireValid }],
        price: [
          {
            validator: this.requireValid
          }
        ],
        endTime: [
          {
            validator: this.requireValid
          }
        ],
        amount: [
          {
            validator: this.requireValid
          }
        ],
        buyerAmount: [
          {
            validator: this.requireValid
          }
        ],
        goodsCounts: [
          {
            validator: this.requireValid
          }
        ],
        realCount: [
          {
            validator: this.requireValid
          }
        ],
        receiveGoodsTime: [
          {
            validator: this.requireValid
          }
        ],
        settleAmount: [
          {
            validator: this.requireValid
          }
        ]
      },
      contractListType: [], // 业务类型选择框
      taxType: $C.TAX_TYPE.options, // 是否含税类型选择框
      priceType: $C.PRICE_TYPE.options,
      url: "",
      visible: false,
      buyerOrdersId: null, // 关联托运人订单ID
      file: null, // 上传
      imgUrl: null,
      orderPicUUID: [],
      chainIdColumn: [{ field: "chainNum", title: "主订单编号" }], // 关联主订单下拉框数据列
      dicByParentData: [],
      dicByParentColumn: [{ field: "dictText", title: "企业名称" }], // 选择平台企业下拉框数据列
      loading: false,
      chainIdData: [], // 关联主订单数据
      chainIdPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini"
      }, // 关联主订单分页
      filterChainId: null, // 关联主订单搜索
      filterSellerName: null, // 承运人订单搜索
      contractVisible: false, // 是否显示选择合同弹窗
      isShowModal: false, // 是否显示选择用户账户弹窗
      orderVisible: false, // 是否显示选择订单
      carShipVisible: false, // 是否显示车船号弹窗
      carShipInfo: null,
      newGoodsArr: [],
      actionUrl: "", // 初始化上传地址
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token
      },
      viewer: null,
      usedType: 2, // 1-合同,2-托运人订单,3-承运人订单,4-实际承运人订单
      isSuccess: false,
      goodDeleteIds: [],
      chainObj: {
        chainId: null,
        chainNum: null
      },
      isShowPicBox: false,
      lookImageData: [],
      showPicIndex: 0,
      dataTmp: {
        index: 1,
        isNeeded: "选填",
        isGenerateNeeded: "选填",
        fileList: null,
        orderPicUUID: null,
        addTime: null,
        goodsName: null, // 货名
        goodsType: null,
        rule: null, // 规格
        packUnit: null,
        unit: null, // 单位
        counts: null, // 数量
        price: null, // 单价
        amount: null,
        buyerAmount: null,
        priceType: null,
        isTax: null, // 是否含税
        carShipNum: null, // 车船号
        transportationType: null,
        deliveryPoints: null, // 交货地点
        beginPlace: null, // 起运地
        beginPlaceArea: [],
        beginPlaceAddress: null,
        endPlaceArea: [],
        endPlaceAddress: null,
        endPlace: null, // 到达地
        beginTime: null, // 交接受载期
        endTime: null,
        isNeedContractImg: 0,
        prepayment: null, // 定金
        demurrageAmount: null, // 滞期费
        loadDay: null, // 装卸天数
        payWay: null, // 付款方式
        deliveryWay: null, // 计量及交接方式
        specificClauseExtra: null, // 特别约定
        driverId: null,
        driverName: null,
        driverPhone: null,
        collectionName: null,
        collectionBank: null,
        collectionAccount: null,
        ifGenerate: null, // 是否生成物流及结算
        logisticsNum: null, // 物流单号
        goodsCounts: null, // 装货数量
        realCount: null, // 实际数量
        logisticsNote: null, // 物流备注
        receiveGoodsTime: null, // 结算时间
        settleAmount: null, // 结算金额
        receiveGoodsNote: null, // 结算摘要
        isTop: null,
        province: null,
        city: null,
        area: null,
        endProvince: null,
        endCity: null,
        endArea: null
      },
      isShowMoreFlied: false,
      isShowImportGoods: false,
      driverIndex: "",
      driverModal: false,
      isShowDriver: false,
      eidtGoodsArr: null,
      isImpot: false,
      goodsTypeOptions: [],
      unitTypeOptions: [],
      cityData: [],
      isTopTypeOptions: $C.LogisticsIsTopStatus.options
    };
  },
  computed: {
    formData: {
      get() {
        let arr = [];
        if (this.type === 0) {
          arr = [
            {
              id: null,
              buyerOrdersId: null, // 关联托运人订单
              contractNum: null, // 合同号
              contractTitle: null, // 订单标题
              contractId: null, // 合同ID
              contractBusType: null, // 业务类型
              buyerName: null, // 托运人名称
              sellerName: null, // 承运人名称
              addWay: 1,
              salesMan: null,
              salesManId: null,
              salesManager: null,
              salesManagerId: null
            }
          ];
        } else if (this.type === 2) {
          // 从托运人订单过来
          arr = [
            {
              id: null,
              contractNum: null, // 合同号
              contractTitle: null, // 订单标题
              contractId: null, // 合同ID
              contractBusType: null, // 业务类型
              buyerName: null, // 托运人名称
              sellerName: null, // 承运人名称
              buyerNameId: null,
              addWay: 1,
              salesMan: null,
              salesManId: null,
              salesManager: null,
              salesManagerId: null
            }
          ];
          if (this.rowInfo) {
            arr[0]["buyerOrdersId"] = this.rowInfo.buyerOrdersNum;
            arr[0]["chainId"] = this.rowInfo.chainId;
            arr[0]["chainNum"] = this.rowInfo.chainNum;
          }
        } else {
          arr = [
            {
              id: this.rowInfo.id,
              chainId: this.rowInfo.chainId, // 关联主订单ID
              chainNum: this.rowInfo.chainNum, // 关联主订单
              buyerOrdersId: this.rowInfo.buyerOrdersNum, // 关联托运人订单
              contractId: this.rowInfo.contractId, // 合同ID
              contractNum: this.rowInfo.contractNum, // 合同号
              contractTitle: this.rowInfo.contractTitle, // 订单标题
              contractBusType: this.rowInfo.contractBusType, // 业务类型
              buyerName: this.rowInfo.buyerName, // 托运人名称
              sellerName: this.rowInfo.sellerName, // 承运人名称
              buyerNameId: this.rowInfo.platformCompanyId, // 平台企业ID
              salesMan: this.rowInfo.salesManName,
              salesManId: this.rowInfo.salesMan,
              salesManager: this.rowInfo.salesManagerName,
              salesManagerId: this.rowInfo.salesManager
            }
          ];
        }
        return arr;
      },
      set() {}
    },
    goodsArr: {
      get() {
        if (this.type === 0 || this.type === 2) {
          return this.newGoodsArr;
        } else {
          let goodsArr = [];
          if (this.eidtGoodsArr && this.eidtGoodsArr.length > 0) {
            goodsArr = this.eidtGoodsArr.map(v => {
              let beginPlaceArea;
              let province;
              let city;
              let area;
              let endProvince;
              let endCity;
              let endArea;
              if (v.beginPlaceArea) {
                if (Array.isArray(v.beginPlaceArea)) {
                  beginPlaceArea = v.beginPlaceArea;
                } else {
                  beginPlaceArea = v.beginPlaceArea.split(",");
                }
                if (beginPlaceArea.length == 2) {
                  city = beginPlaceArea[0];
                  area = beginPlaceArea[1];
                } else {
                  city = beginPlaceArea[1];
                  area = beginPlaceArea[2];
                }
                province = beginPlaceArea[0];
              } else {
                beginPlaceArea = [];
                province = "";
                city = "";
                area = "";
              }
              let endPlaceArea;
              if (v.endPlaceArea) {
                if (Array.isArray(v.endPlaceArea)) {
                  endPlaceArea = v.endPlaceArea;
                } else {
                  endPlaceArea = v.endPlaceArea.split(",");
                }
                if (endPlaceArea.length == 2) {
                  endCity = endPlaceArea[0];
                  endArea = endPlaceArea[1];
                } else {
                  endCity = endPlaceArea[1];
                  endArea = endPlaceArea[2];
                }
                endProvince = endPlaceArea[0];
              } else {
                endPlaceArea = [];
                endProvince = "";
                endCity = "";
                endArea = "";
              }
              return {
                id: v.id,
                isNeeded: "选填",
                fileList: v.orderPicUrl,
                addTime: v.addTime ? timeFormatDate(v.addTime) : null,
                goodsName: v.goodsName, // 货名
                goodsType: v.goodsType, // 货物类型
                rule: v.rule, // 规格
                packUnit: v.packUnit,
                unit: v.unit, // 单位
                counts: v.counts, // 数量
                price: v.price, // 单价
                amount: v.amount,
                buyerAmount: v.buyerAmount,
                priceType: v.priceType,
                isTax: v.isTax, // 是否含税
                carShipNum: v.carShipNum, // 车船号
                transportationType: v.transportationType,
                deliveryPoints: v.deliveryPoints, // 交货地点
                // beginPlaceArea,
                province,
                city,
                area,
                endProvince,
                endCity,
                endArea,
                cityOptions: this.getCityOptions(province),
                endCityOptions: this.getCityOptions(endProvince),
                areaOptions: this.getAreaOptions(province, city),
                endAreaOptions: this.getAreaOptions(endProvince, endCity),
                beginPlaceAddress: v.beginPlaceAddress,
                // endPlaceArea,
                endPlaceAddress: v.endPlaceAddress,
                // beginPlace: v.beginPlace, // 起运地
                // endPlace: v.endPlace, // 到达地
                beginTime: v.beginTime
                  ? moment(v.beginTime).format("YYYY-MM-DD HH:mm:ss")
                  : null, // 交接受载期
                endTime: v.endTime
                  ? moment(v.endTime).format("YYYY-MM-DD HH:mm:ss")
                  : null,
                isNeedContractImg: 0,
                prepayment: v.prepayment, // 定金
                demurrageAmount: v.demurrageAmount, // 滞期费
                loadDay: v.loadDay, // 装卸天数
                payWay: v.payWay, // 付款方式
                deliveryWay: v.deliveryWay, // 计量及交接方式
                specificClauseExtra: v.specificClauseExtra, // 特别约定
                driverId: v.driverId,
                driverPhone: v.driverPhone,
                driverName: v.driverName,
                collectionName: v.collectionName,
                collectionBank: v.collectionBank,
                collectionAccount: v.collectionAccount,
                ifGenerate: 0, // 是否生成物流及结算
                logisticsNum: v.logisticsNum, // 物流单号
                goodsCounts: v.goodsCounts, // 装货数量
                realCount: v.realCount, // 实际数量
                logisticsNote: v.logisticsNote, // 物流备注
                receiveGoodsTime: v.receiveGoodsTime
                  ? timeFormatDate(v.receiveGoodsTime)
                  : null, // 结算时间
                settleAmount: v.settleAmount, // 结算金额
                receiveGoodsNote: v.receiveGoodsNote, // 结算摘要
                isTop: v.isTop
              };
            });
          }
          return goodsArr;
        }
      },
      set(v) {}
    }
  },
  watch: {
    isShowAddModal: {
      deep: true,
      immediate: true,
      handler: function(val, oldVal) {
        if (val == false && oldVal == true) {
          this.reset();
        }
        if (val == true) {
          this.init();
          if (this.type === 1) {
            this.getEditGoodsRtnVos();
          }
        }
      }
    }
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  methods: {
    init() {
      if (this.formData[0].contractBusType === 1) {
        this.isShowMoreFlied = true;
        this.isShowDriver = false;
      } else if (this.formData[0].contractBusType === 2) {
        this.isShowMoreFlied = false;
        this.isShowDriver = true;
      }
      if (this.type !== 1) {
        if (this.$refs.xTable.getTableData().fullData.length > 0) {
          this.$refs.xTable.remove();
        }
      }
      this.getDicDate();
    },
    getDicDate() {
      this.contractListType = [];
      this.goodsTypeOptions = [];
      this.unitTypeOptions = [];
      $api.other.getContractBusTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100
          }
        })
        .then(res => {
          res.data.forEach(item => {
            var obj = {
              label: item.dictText,
              value: parseInt(item.note)
            };
            this.contractListType.push(obj);
          });
        });
      $api.other.getGoodsTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100
          }
        })
        .then(res => {
          res.data.forEach(item => {
            var obj = {
              label: item.dictText,
              value: item.dictText
            };
            this.goodsTypeOptions.push(obj);
          });
        });
      $api.other.getUnitTypeModel
        .GET({
          params: {
            page: 1,
            rows: 100
          }
        })
        .then(res => {
          res.data.forEach(item => {
            var obj = {
              label: item.dictText,
              value: item.dictText
            };
            this.unitTypeOptions.push(obj);
          });
        });

      appData.forEach(item => {
        let obj = {
          value: item.label,
          label: item.label
          // children: [],
          // loading: false
        };
        this.cityData.push(obj);
      });
    },
    getCityOptions(province) {
      if (isEmpty(province)) {
        return [];
      }
      let options;
      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
        isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        options = arr;
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        options = cityArr;
      }
      return options;
    },
    getAreaOptions(province, city) {
      if (isEmpty(province)) {
        return [];
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      return arr;
    },
    loadCity(province, index, type, isImpot = false) {
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (!isImpot) {
        if (type === 1) {
          tableData[index].city = "";
          tableData[index].area = "";
        } else {
          tableData[index].endCity = "";
          tableData[index].endArea = "";
        }
      }

      let cityOptions = appData.filter(i => i.label === province);
      let isHasChildren = cityOptions[0].children.some(m =>
        isNotEmpty(m.children)
      );
      if (isHasChildren) {
        let arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
        type === 1
          ? (tableData[index].cityOptions = arr)
          : (tableData[index].endCityOptions = arr);
      } else {
        let cityArr = [
          {
            label: province,
            value: province
          }
        ];
        type === 1
          ? (tableData[index].cityOptions = cityArr)
          : (tableData[index].endCityOptions = cityArr);
      }
    },
    loadArea(province, city, index, type, isImpot = false) {
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (!isImpot) {
        if (type === 1) {
          tableData[index].area = "";
        } else {
          tableData[index].endArea = "";
        }
      }
      let cityOptions = appData.filter(i => i.label === province);
      let arr = [];
      if (province === city) {
        arr = cityOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      } else {
        let areaOptions = cityOptions[0].children.filter(i => i.label === city);
        arr = areaOptions[0].children.map(i => {
          return {
            label: i.label,
            value: i.label
          };
        });
      }
      type === 1
        ? (tableData[index].areaOptions = arr)
        : (tableData[index].endAreaOptions = arr);
    },
    loadData(item, callback) {
      const getTree = jsonObj => {
        function toParse(jsonObj) {
          jsonObj.forEach(item => {
            item.value = item.label;
            if (item.children && Array.isArray(item.children)) {
              toParse(item.children);
            }
          });
          return jsonObj;
        }
        return toParse(jsonObj);
      };
      var curCityData = getTree(appData);
      item.loading = true;
      setTimeout(() => {
        let arr = curCityData.filter(i => {
          return i.label === item.value;
        });
        item.children = arr[0].children;
        item.loading = false;
        callback();
      }, 1000);
    },
    getEditGoodsRtnVos() {
      let id = this.rowInfo.id;
      $api.order.queryOrdersSellerDetailModel
        .POST({
          data: {
            id,
            page: 1,
            rows: 10000
          }
        })
        .then(res => {
          if (res.status === 1) {
            this.eidtGoodsArr = res.data.goodsRtnVos;
          }
        });
    },
    downloadFile(url) {
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      document.body.appendChild(link);
      link.click();
    },
    changeContractType(e) {
      this.isShowMoreFlied = e.value === 1 ? true : false;
      this.isShowDriver = e.value === 2 ? true : false;
      if (!this.isImpot) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        // this.$refs.xTable.reloadData(tableData)
        // debugger
        tableData.forEach(item => {
          item.carShipNum = null;
          item.transportationType = null;
          item.driverName = null;
          item.driverPhone = null;
        });
      }
      this.clearValidate("infotabel");
    },
    changeNeedContractImg(obj, i) {
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (obj.isNeedContractImg === 1) {
        tableData[i].isNeeded = "必填";
      } else {
        tableData[i].isNeeded = "选填";
      }
    },
    importGoods() {
      this.isShowImportGoods = true;
    },
    impotEvent() {
      let errTimeLine = "";
      let isHaveErr = false;
      this.$refs.xTable
        .readFile({
          types: ["xls", "xlsx"]
        })
        .then(evnt => {
          this.$Spin.show({
            render: h => {
              return h("div", [
                h("Icon", {
                  class: "demo-spin-icon-load",
                  props: {
                    type: "ios-loading",
                    size: 18
                  }
                }),
                h("div", "导入中...")
              ]);
            }
          });
          const files = evnt.target.files;
          const fileReader = new FileReader();
          this.isImpot = true;
          this.$refs.xTable.remove();

          fileReader.onload = ev => {
            const data = ev.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const csvData = XLSX.utils.sheet_to_csv(
              Object.values(workbook.Sheets)[0]
            );
            const tableData = [];
            // 解析数据
            csvData.split("\n").forEach((vRow, index) => {
              if (vRow && index > 0) {
                const vCols = vRow.split(",");
                let beginTime;
                let endTime;
                if (vCols[13] === "车辆") {
                  beginTime = moment(vCols[15]).format("YYYY-MM-DD HH:mm:ss");
                  endTime = moment(vCols[17]).format("YYYY-MM-DD HH:mm:ss");
                  if (vCols[15].length < 12 || vCols[17].length < 12) {
                    errTimeLine += `${index},`;
                    isHaveErr = true;
                    if (vCols[15].length < 12) {
                      beginTime = null;
                    }
                    if (vCols[17].length < 12) {
                      endTime = null;
                    }
                  }
                } else {
                  beginTime = moment(vCols[15]).format("YYYY-MM-DD");
                  endTime = moment(vCols[17]).format("YYYY-MM-DD");
                }

                const item = {
                  no: vCols[0],
                  addTime: getExcelTime(vCols[1]),
                  goodsType: vCols[2],
                  goodsName: vCols[3],
                  rule: vCols[4], // 规格
                  // packUnit: vCols[4],
                  unit: vCols[5], // 单位
                  counts: vCols[6], // 数量
                  price: vCols[7], // 单价
                  amount: vCols[8],
                  buyerAmount: vCols[9],
                  priceType: vCols[10],
                  isTax: vCols[11], // 是否含税
                  carShipNum: vCols[12], // 车船号
                  transportationType: vCols[13], // 车船号
                  // beginPlace: vCols[13], // 起运地
                  // endPlace: vCols[15], // 到达地
                  beginTime, // 交接受载期
                  endTime,
                  driverName: vCols[18],
                  driverPhone: vCols[19],
                  isNeedContractImg: vCols[20],
                  collectionName: vCols[21],
                  collectionBank: vCols[22],
                  collectionAccount: vCols[23],
                  prepayment: vCols[24],
                  demurrageAmount: vCols[25],
                  loadDay: vCols[26],
                  payWay: vCols[27],
                  deliveryWay: vCols[28],
                  specificClauseExtra: vCols[29],
                  ifGenerate: vCols[30], // 是否生成物流及结算
                  logisticsNum: vCols[31], // 物流单号
                  goodsCounts: vCols[33], // 装货数量
                  realCount: vCols[34], // 实际数量
                  logisticsNote: vCols[35], // 物流备注
                  receiveGoodsTime: getExcelTime(vCols[36]), // 结算时间
                  settleAmount: vCols[37], // 结算金额
                  receiveGoodsNote: vCols[38], // 结算摘要
                  fileAddUuidList: [],
                  fileAddUrlList: [],
                  fileUuidList: []
                };
                // console.log(moment(vCols[15]).format("YYYY-MM-D h:mm:ss"));
                const findKey = (obj, value, compare = (a, b) => a === b) => {
                  return Object.keys(obj).find(k => compare(obj[k], value));
                };
                if (vCols[32]) {
                  let obj = $C.LogisticsIsTopStatus.map;
                  let val = vCols[32];
                  item.isTop = parseInt(findKey(obj, val));
                } else {
                  item.isTop = null;
                }

                if (vCols[14]) {
                  if (vCols[13] === "车辆") {
                    let beginPlaceArea = [];
                    let address = this.$AddressParse(vCols[14], 0);
                    item.province = address.province;
                    item.city = address.city;
                    item.area = address.area;
                    beginPlaceArea.push(
                      address.province,
                      address.city,
                      address.area
                    );
                    item.beginPlaceArea = beginPlaceArea;
                    // console.log(item.beginPlaceArea);
                    item.beginPlaceAddress = address.detail || address.name;
                  } else {
                    item.beginPlaceArea = [];
                    // console.log(item.beginPlaceArea);
                    item.beginPlaceAddress = vCols[14];
                  }
                }
                if (vCols[16]) {
                  if (vCols[13] === "车辆") {
                    let endPlaceArea = [];
                    let endAddress = this.$AddressParse(vCols[16], 0);
                    item.endProvince = endAddress.province;
                    item.endCity = endAddress.city;
                    item.endArea = endAddress.area;
                    endPlaceArea.push(
                      endAddress.province,
                      endAddress.city,
                      endAddress.area
                    );
                    item.endPlaceArea = endPlaceArea;
                    item.endPlaceAddress = endAddress.detail || endAddress.name;
                  } else {
                    item.endPlaceArea = [];
                    item.endPlaceAddress = vCols[16];
                  }
                }

                if (vCols[13] === "车辆") {
                  item.transportationType = 1;
                  // this.formData[0].contractBusType = 2;

                  item.prepayment = null;
                  item.demurrageAmount = null;
                  item.loadDay = null;
                  item.payWay = null;
                  item.deliveryWay = null;
                  item.specificClauseExtra = null;
                  // this.isShowMoreFlied = false;
                  // this.isShowDriver = true;
                } else if (vCols[13] === "船舶") {
                  item.transportationType = 2;
                  item.driverName = null;
                  item.driverPhone = null;
                  // this.formData[0].contractBusType = 1;
                  // this.isShowMoreFlied = true;
                  // this.isShowDriver = false;
                }

                switch (vCols[10]) {
                  case "单价":
                    item.priceType = 1;
                    break;
                  case "包车":
                    item.priceType = 2;
                    break;
                  case "包船":
                    item.priceType = 3;
                    break;
                }
                switch (vCols[11]) {
                  case "是":
                    item.isTax = 1;
                    break;
                  case "否":
                    item.isTax = 0;
                    break;
                }
                switch (vCols[20]) {
                  case "是":
                    item.isNeedContractImg = 1;
                    break;
                  case "否":
                    item.isNeedContractImg = 0;
                    break;
                }
                switch (vCols[30]) {
                  case "是":
                    item.ifGenerate = 1;
                    break;
                  case "否":
                    item.ifGenerate = 0;
                    break;
                }
                tableData.push(item);
              }
            });
            if (this.type === 0 || this.type === 2) {
              this.newGoodsArr = tableData;
            } else {
              this.eidtGoodsArr = tableData;
            }
            // tableData.forEach((i) => {
            //   this.$refs.xTable.insertAt(i, -1);
            // });
          };
          fileReader.readAsBinaryString(files[0]);
          setTimeout(() => {
            let arr = this.$refs.xTable.getTableData().tableData;
            arr.forEach((item, index) => {
              if (item.transportationType === 1) {
                this.loadCity(item.province, index, 1, true);
                this.loadCity(item.endProvince, index, 2, true);
                this.loadArea(item.province, item.city, index, 1, true);
                this.loadArea(item.endProvince, item.endCity, index, 2, true);
              }
            });
            this.$Spin.hide();
            this.isShowImportGoods = false;
            if (isHaveErr) {
              this.$XModal.alert({
                message: "第" + errTimeLine + "行，日期格式错误",
                status: "error"
              });
              isHaveErr = false;
            }
          }, 3000);
        });
    },
    setSaleMan(data, status) {
      if (status === 1) {
        this.formData[0].salesMan = data.salesMan;
        this.formData[0].salesManId = data.salesManId;
        this.formData[0].salesManager = data.salesManager;
        this.formData[0].salesManagerId = data.salesManagerId;
      } else {
        this.formData[0].salesMan = data.username;
        this.formData[0].salesManId = data.id;
        this.formData[0].salesManager = null;
        this.formData[0].salesManagerId = null;
      }
    },
    resetUploadData() {
      this.uploadList = [];
    },
    countAllAmount(i) {
      let counts = 0;
      let isCounts = true;
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (
        tableData[i].price === "" ||
        tableData[i].price === null ||
        tableData[i].counts === "" ||
        tableData[i].counts === null
      ) {
        isCounts = false;
      } else {
        let multiply = this.$utils.multiply(
          tableData[i].counts,
          tableData[i].price
        );
        counts = counts + multiply;
        tableData[i].amount = Math.round(counts * 100) / 100;
      }
    },
    clearValidate(tableName) {
      let table = this.$refs[tableName];
      table.clearValidate();
    },
    async requireValid(e) {
      if (e.column.title == "托运人金额" && !isEmpty(e.row.buyerAmount)) {
        let arr = e.row.buyerAmount.toString().split(".")[1];
        if (arr && arr.length > 2) {
          return Promise.reject(
            new Error("托运人金额最多只能输入小数点后两位")
          );
        }
      }
      if (e.row.isNeedContractImg === 1 || e.row.ifGenerate === 1) {
        if (
          e.row.contractBusType === 2 &&
          e.column.title == "托运人金额" &&
          isEmpty(e.row.buyerAmount)
        ) {
          return Promise.reject(new Error("请填写托运人金额"));
        }
        // if (
        //   this.formData[0].contractBusType === 2 &&
        //   e.column.title == "起运地" &&
        //   isEmpty(e.row.beginPlaceArea)
        // ) {
        //   return Promise.reject(new Error("请选择起运地省市区/县"));
        // }
        // if (
        //   this.formData[0].contractBusType === 2 &&
        //   e.column.title == "到达地" &&
        //   isEmpty(e.row.endPlaceArea)
        // ) {
        //   return Promise.reject(new Error("请选择到达地省市区/县"));
        // }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "起运地(省)" &&
          isEmpty(e.row.province)
        ) {
          return Promise.reject(new Error("请选择起运地省"));
        }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "起运地(市)" &&
          isEmpty(e.row.city)
        ) {
          return Promise.reject(new Error("请选择起运地市"));
        }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "起运地(区)" &&
          isEmpty(e.row.area)
        ) {
          return Promise.reject(new Error("请选择起运地区"));
        }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "到达地(省)" &&
          isEmpty(e.row.endProvince)
        ) {
          return Promise.reject(new Error("请选择到达地省"));
        }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "到达地(市)" &&
          isEmpty(e.row.endCity)
        ) {
          return Promise.reject(new Error("请选择到达地市"));
        }
        if (
          this.formData[0].contractBusType === 2 &&
          e.column.title == "到达地(区)" &&
          isEmpty(e.row.endArea)
        ) {
          return Promise.reject(new Error("请选择到达地区"));
        }
        if (
          e.row.contractBusType === 2 &&
          e.column.title == "到达时间" &&
          isEmpty(e.row.endTime)
        ) {
          return Promise.reject(new Error("到达时间不能为空"));
        }
        if (
          e.row.priceType === 1 &&
          isEmpty(e.row.price) &&
          e.column.title == "单价"
        ) {
          return Promise.reject(new Error("单价不能为空"));
        }
        if (
          (e.row.priceType === 2 || e.row.priceType === 3) &&
          isEmpty(e.row.amount) &&
          e.column.title == "总金额"
        ) {
          return Promise.reject(new Error("总金额不能为空"));
        }
        if (
          e.row.ifGenerate === 1 &&
          isEmpty(e.row.goodsCounts) &&
          e.column.title == "装货数量"
        ) {
          return Promise.reject(new Error("请填写装货数量"));
        }
        if (
          e.row.ifGenerate === 1 &&
          isEmpty(e.row.realCount) &&
          e.column.title == "实际数量"
        ) {
          return Promise.reject(new Error("请填写实际数量"));
        }
        if (
          e.row.ifGenerate === 1 &&
          isEmpty(e.row.receiveGoodsTime) &&
          e.column.title == "结算时间"
        ) {
          return Promise.reject(new Error("请填写结算时间"));
        }
        if (
          e.row.ifGenerate === 1 &&
          isEmpty(e.row.settleAmount) &&
          e.column.title == "结算金额"
        ) {
          return Promise.reject(new Error("请填写结算金额"));
        }
        if (
          empties.includes(e.cellValue) &&
          ![
            "到达时间",
            "单价",
            "总金额",
            "装货数量",
            "实际数量",
            "结算时间",
            "结算金额",
            "托运人金额",
            "起运地(省)",
            "起运地(市)",
            "起运地(区)",
            "到达地(省)",
            "到达地(市)",
            "到达地(区)"
          ].includes(e.column.title)
        ) {
          return Promise.reject(new Error(e.column.title + "必填"));
        }
      }

      //       if (
      //   isEmpty(e.row.goodsName) &&
      //   e.column.title == "货名"
      // ) {
      //   return Promise.reject(new Error("货名不能为空"));
      // }
      // if (
      //   isEmpty(e.row.unit) &&
      //   e.column.title == "单位"
      // ) {
      //   return Promise.reject(new Error("单位不能为空"));
      // }
      // if (
      //   isEmpty(e.row.counts) &&
      //   e.column.title == "数量"
      // ) {
      //   return Promise.reject(new Error("数量不能为空"));
      // }
      // if (
      //   isEmpty(e.row.priceType) &&
      //   e.column.title == "计费方式"
      // ) {
      //   return Promise.reject(new Error("计费方式不能为空"));
      // }
      // if (
      //   isEmpty(e.row.isTax) &&
      //   e.column.title == "是否含税"
      // ) {
      //   return Promise.reject(new Error("是否含税不能为空"));
      // }
      // if (
      //   isEmpty(e.row.carShipNum) &&
      //   e.column.title == "车船号"
      // ) {
      //   return Promise.reject(new Error("车船号不能为空"));
      // }
      // if (
      //   isEmpty(e.row.beginPlace) &&
      //   e.column.title == "起运地"
      // ) {
      //   return Promise.reject(new Error("起运地不能为空"));
      // }
      // if (
      //   isEmpty(e.row.endPlace) &&
      //   e.column.title == "到达地"
      // ) {
      //   return Promise.reject(new Error("到达地不能为空"));
      // }
      // if (
      //   isEmpty(e.row.beginTime) &&
      //   e.column.title == "受载/起运时间"
      // ) {
      //   return Promise.reject(new Error("受载/起运时间不能为空"));
      // }
      // if (
      //   this.formData[0].contractBusType === 2 &&
      //   e.column.title == "到达时间" &&
      //   isEmpty(e.row.endTime)
      // ) {
      //   return Promise.reject(new Error("到达时间不能为空"));
      // }
      // if (
      //   e.row.priceType === 1 &&
      //   isEmpty(e.row.price) &&
      //   e.column.title == "单价"
      // ) {
      //   return Promise.reject(new Error("单价不能为空"));
      // }
      // if (
      //   (e.row.priceType === 2 || e.row.priceType === 3) &&
      //   isEmpty(e.row.amount) &&
      //   e.column.title == "总金额"
      // ) {
      //   return Promise.reject(new Error("总金额不能为空"));
      // }
      // if (
      //   e.row.ifGenerate === 1 &&
      //   isEmpty(e.row.goodsCounts) &&
      //   e.column.title == "装货数量"
      // ) {
      //   return Promise.reject(new Error("请填写装货数量"));
      // }
      // if (
      //   e.row.ifGenerate === 1 &&
      //   isEmpty(e.row.realCount) &&
      //   e.column.title == "实际数量"
      // ) {
      //   return Promise.reject(new Error("请填写实际数量"));
      // }
      // if (
      //   e.row.ifGenerate === 1 &&
      //   isEmpty(e.row.receiveGoodsTime) &&
      //   e.column.title == "结算时间"
      // ) {
      //   return Promise.reject(new Error("请填写结算时间"));
      // }
      // if (
      //   e.row.ifGenerate === 1 &&
      //   isEmpty(e.row.settleAmount) &&
      //   e.column.title == "结算金额"
      // ) {
      //   return Promise.reject(new Error("请填写结算金额"));
      // }
    },
    async fullValidEvent(i) {
      // this.getUpdateEvent()
      if (this.formData[0].salesManId && this.formData[0].salesManId !== "") {
        const errMap = await this.$refs.infotabel
          .fullValidate()
          .catch(errMap => errMap);
        if (errMap) {
          return;
        } else {
          let selectRecords = [];

          this.$refs.xTable.getTableData().fullData.forEach((item, index) => {
            selectRecords.push(item);
          });
          const errXtabelMap = await this.$refs.xTable
            .validate(selectRecords)
            .catch(errMap => errMap);
          if (errXtabelMap) {
            return;
          } else {
            this.createOrder(i);
          }
        }
      } else {
        this.$XModal.alert({
          message: "请选择业务员",
          status: "error"
        });
      }
    },
    reset() {
      // 重置数据
      this.isShowMoreFlied = false;
      this.isImpot = false;
      this.formData[0].salesMan = null;
      this.formData[0].salesManId = null;
      this.formData[0].salesManager = null;
      this.formData[0].salesManagerId = null;
      this.formData[0].buyerOrdersId = null;
      this.formData[0].contractId = null;
      this.formData[0].contractNum = null;
      this.formData[0].contractTitle = null;
      this.formData[0].contractId = null;
      this.formData[0].addWay = null;
      this.formData[0].amountTotal = null;
      this.formData[0].buyerName = null;
      this.formData[0].sellerName = null;
      this.formData[0].buyerNameId = null;
      this.formData[0].contractBusType = null;
      this.goodDeleteIds = [];
      this.newGoodsArr = [];
      this.chainObj.chainId = null;
      this.chainObj.chainNum = null;
      this.buyerOrdersId = null;
      this.formData[0].chainId = null;
      this.formData[0].chainNum = null;

      this.$refs.infotabel.reloadData(this.formData);
      this.$refs.xTable.reloadData(this.newGoodsArr);
      this.$refs.saleHeader.setSaleData(null, null);
    },
    insertEvent() {
      // 插入货物
      let tableData = this.$refs.xTable.getTableData().tableData;
      this.$refs.xTable.clearValidate();
      let record = assign(this.dataTmp);
      record.index = tableData.length + 1;
      record.fileList = [];
      record.orderPicUUID = [];
      this.$refs.xTable.insertAt(record, -1);
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择"
        });
        return;
      }
      //不能全部删除
      // if (
      //   checkboxRecords.length ==
      //   this.$refs.xTable.getTableData().tableData.length
      // ) {
      //   this.$XModal.message({
      //     message: "不能全部删除,至少保留一条",
      //   });
      //   return;
      // }

      let confirmRes = await this.$XModal.confirm(
        "删除后不可恢复",
        "是否删除？"
      );
      if (confirmRes == "confirm") {
        this.$refs.xTable.removeCheckboxRow();
        checkboxRecords.forEach(item => {
          this.goodDeleteIds.push(item.id);
        });
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      let copyRow = [];
      checkboxRecords.forEach(item => {
        let paramsObj = {};
        Object.keys(item).forEach(key => {
          if (key !== "id") {
            paramsObj[key] = item[key];
          }
        });
        copyRow.push(paramsObj);
      });
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: "没有选择"
        });
        return;
      }
      this.$refs.xTable.insertAt(copyRow, -1);
    },
    createOrder(type) {
      // 0：继续新建  1: 提交
      this.isSuccess = false;
      let obj = {};
      if (this.type === 2) {
        this.buyerOrdersId = this.$route.params.id;
      }
      obj.chainId = this.formData[0].chainId;
      obj.chainNum = this.formData[0].chainNum;
      obj.id = this.formData[0].id;
      // obj.chainId = this.chainObj.chainId;
      // obj.chainNum = this.chainObj.chainNum;
      obj.buyerOrdersId = this.buyerOrdersId; // 关联托运人订单编号 这里是ID值 不是 chainNum 供应链编码
      obj.contractId = this.formData[0].contractId; // 合同ID
      obj.contractNum = this.formData[0].contractNum; // 合同号
      obj.contractBusType = this.formData[0].contractBusType; // 业务类别
      obj.contractTitle = this.formData[0].contractTitle; // 订单标题
      obj.contractId = this.formData[0].contractId; // 合同ID
      obj.buyerName = this.formData[0].buyerName; // 托运人名称
      obj.sellerName = this.formData[0].sellerName; // 承运人名称
      obj.platformCompanyId = this.formData[0].buyerNameId; // 平台企业
      // obj.amountTotal = this.formData[0].amountTotal; // 合同总金额
      // obj.addTime = timeToVal(this.formData[0].addTime); // 签约日期
      obj.salesMan = this.formData[0].salesManId;
      obj.salesManager = this.formData[0].salesManagerId;

      obj.addWay = 1; // 签约方式 默认1
      let tableData = this.$refs.xTable.getTableData().fullData;

      if (tableData && tableData.length > 0) {
        obj.goods = tableData.map((v, index) => {
          // 编辑时可能出现 导入transportationType 为null  需要根据类型来判断
          let transportationType = v.transportationType;
          if (this.type === 1 && isEmpty(v.transportationType)) {
            if (this.formData[0].contractBusType == 1) {
              transportationType = 2;
            } else if (this.formData[0].contractBusType == 2) {
              transportationType = 1;
            }
          }
          let beginPlaceArea = isNotEmpty(v.area)
            ? v.province === v.city
              ? `${v.city},${v.area}`
              : `${v.province},${v.city},${v.area}`
            : "";
          let beginPlaceArea2 = isNotEmpty(v.area)
            ? v.province === v.city
              ? `${v.city}${v.area}`
              : `${v.province}${v.city}${v.area}`
            : "";

          let endPlaceArea = isNotEmpty(v.endArea)
            ? v.endProvince === v.endCity
              ? `${v.endCity},${v.endArea}`
              : `${v.endProvince},${v.endCity},${v.endArea}`
            : "";
          let endPlaceArea2 = isNotEmpty(v.endArea)
            ? v.endProvince === v.endCity
              ? `${v.endCity}${v.endArea}`
              : `${v.endProvince}${v.endCity}${v.endArea}`
            : "";
          // let beginPlaceArea = isNotEmpty(v.beginPlaceArea)
          //   ? v.beginPlaceArea.join(",")
          //   : "";
          // let beginPlaceArea2 = isNotEmpty(v.beginPlaceArea)
          //   ? v.beginPlaceArea.join("")
          //   : "";
          // let endPlaceArea = isNotEmpty(v.endPlaceArea)
          //   ? v.endPlaceArea.join(",")
          //   : "";
          // let endPlaceArea2 = isNotEmpty(v.endPlaceArea)
          //   ? v.endPlaceArea.join("")
          //   : "";
          let beginPlaceAddress = isNotEmpty(v.beginPlaceAddress)
            ? v.beginPlaceAddress
            : "";
          let endPlaceAddress = isNotEmpty(v.endPlaceAddress)
            ? v.endPlaceAddress
            : "";
          let beginPlace = beginPlaceArea2 + beginPlaceAddress;
          let endPlace = endPlaceArea2 + endPlaceAddress;
          let goodsObj = {
            index: index + 1,
            orderPicUUID: v.fileUuidList,
            addTime: timeToVal(v.addTime),
            goodsName: v.goodsName, // 货名
            goodsType: v.goodsType,
            rule: v.rule, // 规格
            packUnit: v.packUnit,
            unit: v.unit, // 单位
            counts: v.counts, // 数量
            price: v.price, // 单价
            amount: v.amount,
            buyerAmount: v.buyerAmount,
            priceType: v.priceType,
            isTax: v.isTax, // 是否含税
            carShipNum: v.carShipNum, // 车船号
            carShipId: v.carShipId, // 车船id
            transportationType, // 车船类型
            deliveryPoints: v.deliveryPoints, // 交货地点
            beginPlace, // 起运地
            endPlace, // 到达地
            beginPlaceArea,
            beginPlaceAddress,
            endPlaceArea,
            endPlaceAddress,
            beginTime: timeToVal(v.beginTime), // 交接受载期
            endTime: timeToVal(v.endTime),
            usedType: this.usedType,
            isNeedContractImg: v.isNeedContractImg,
            prepayment: v.prepayment, // 定金
            demurrageAmount: v.demurrageAmount, // 滞期费
            loadDay: v.loadDay, // 装卸天数
            payWay: v.payWay, // 付款方式
            deliveryWay: v.deliveryWay, // 计量及交接方式
            specificClauseExtra: v.specificClauseExtra, // 特别约定
            driverId: v.driverId,
            driverPhone: v.driverPhone,
            driverName: v.driverName,
            collectionName: v.collectionName,
            collectionBank: v.collectionBank,
            collectionAccount: v.collectionAccount,
            ifGenerate: v.ifGenerate, // 是否生成物流及结算
            logisticsNum: v.logisticsNum, // 物流单号
            goodsCounts: v.goodsCounts, // 装货数量
            realCount: v.realCount, // 实际数量
            logisticsNote: v.logisticsNote, // 物流备注
            receiveGoodsTime: timeToVal(v.receiveGoodsTime), // 结算时间
            settleAmount: v.settleAmount, // 结算金额
            receiveGoodsNote: v.receiveGoodsNote, // 结算摘要
            isTop: v.isTop
          };
          this.type === 1 ? (goodsObj.id = v.id) : "";
          return goodsObj;
        });
      }
      // obj.orderPicUUID = this.orderPicUUID;
      // 判断商品明细货运类型是否跟业务类型一致
      let isCanNotSubmit = false;
      if (obj.goods && obj.goods.length > 0) {
        isCanNotSubmit = obj.goods.some(i => {
          if (i.beginTime && i.endTime && i.beginTime > i.endTime) {
            let msg = `第${i.index}行，到达时间不能早于受载/起运时间`;
            this.$XModal.alert({
              message: msg,
              status: "error"
            });
            return true;
          }
          let boolenArr = [];
          boolenArr.push(
            isNotEmpty(i.collectionName),
            isNotEmpty(i.collectionBank),
            isNotEmpty(i.collectionAccount)
          );
          let isboolenArr = [...new Set(boolenArr)];
          if (isboolenArr.length > 1) {
            let msg = `第${i.index}行，收款人、开户行、银行账户字段，必须全为空或全不为空`;
            this.$XModal.alert({
              message: msg,
              status: "error"
            });
            return true;
          }
          if (
            (this.formData[0].contractBusType === 1 &&
              i.transportationType === 1) ||
            (this.formData[0].contractBusType === 2 &&
              i.transportationType === 2)
          ) {
            let msg = `第${i.index}行，业务类型与货运类型不匹配`;
            this.$XModal.alert({
              message: msg,
              status: "error"
            });
            return true;
          }
        });
      }

      if (isCanNotSubmit) {
        return;
      }
      obj.goodDeleteIds = this.goodDeleteIds;
      let messagetxt = null;
      this.type === 1
        ? (messagetxt = "修改成功！")
        : (messagetxt = "添加成功！");
      showLoading();
      $api.order.createOrUpdateOrdersSellerModel
        .POST({
          data: obj
        })
        .then(res => {
          hideLoading();
          if (res.status === 1) {
            this.isSuccess = true;
            this.$XModal.message({ message: messagetxt });
            if (type === 0) {
              this.isSuccess ? this.$emit("closeModal", false) : "";
            }
             this.$bus.$emit("isGetNewSellerOrder", true);
            this.reset();
          } else if (res.status == 0) {
            showFailMsgList(res.data);
          } else {
            this.$XModal.alert({
              message: res.message ? res.message : "接口异常",
              status: "error"
            });
          }
        });
    },
    //选择合同
    openContract() {
      this.contractVisible = true;
      this.$refs.contractModel.init(2);
    },
    //选择订单
    openOrder() {
      this.orderVisible = true;
      this.$refs.orderModel.init(1);
    },
    //选择合同返回
    chooseContract(row) {
      this.formData[0].contractId = row.id;
      this.formData[0].contractNum = row.numb;
      this.formData[0].contractTitle = row.title;
      this.formData[0].addTime = timeFormatDate(row.addTime);
      this.formData[0].addWay = row.addWay;
      console.log(this.type, "this.type");
      if (this.type === 0 || this.type === 2) {
        this.formData[0].amountTotal = row.amountTotal;
      }
      this.formData[0].amountTotal = row.amountTotal;
      this.formData[0].buyerName = row.buyerName;
      this.formData[0].sellerName = row.sellerName;
      this.formData[0].contractBusType = row.busType;
      this.formData[0].buyerNameId = row.platformCompanyId;
      if (row.goodsList && row.goodsList.length > 0) {
        this.newGoodsArr = row.goodsList;
        if (this.rowInfo && this.rowInfo.goodsRtnVos) {
          this.rowInfo.goodsRtnVos = row.goodsList;
        }
      } else {
        this.newGoodsArr = [
          {
            index: 1,
            fileList: null,
            orderPicUUID: null,
            addTime: null,
            goodsName: null, // 货名
            goodsType: null,
            rule: null, // 规格
            packUnit: null,
            unit: null, // 单位
            counts: null, // 数量
            price: null, // 单价
            amount: null,
            buyerAmount: null,
            priceType: null,
            isTax: null, // 是否含税
            carShipNum: null, // 车船号
            transportationType: null,
            deliveryPoints: null, // 交货地点
            beginPlace: null, // 起运地
            endPlace: null, // 到达地
            beginPlaceArea: [],
            beginPlaceAddress: null,
            endPlaceArea: [],
            endPlaceAddress: null,
            beginTime: null, // 交接受载期
            endTime: null,
            isNeedContractImg: 0,
            prepayment: null, // 定金
            demurrageAmount: null, // 滞期费
            loadDay: null, // 装卸天数
            payWay: null, // 付款方式
            deliveryWay: null, // 计量及交接方式
            specificClauseExtra: null, // 特别约定
            driverName: null,
            driverPhone: null,
            collectionName: null,
            collectionBank: null,
            collectionAccount: null,
            isTop: null
          }
        ];
      }
      // this.newGoodsArr = row.goodsList;
      this.contractVisible = false;
    },
    //选择订单
    chooseOrder(row) {
      // console.log(row, '11111111111123')
      this.formData[0].buyerOrdersId = row.buyerOrdersNum;
      this.formData[0].chainId = row.chainId;
      this.formData[0].chainNum = row.chainNum;
      this.buyerOrdersId = row.id;
      this.orderVisible = false;
    },
    openDriver(index) {
      this.driverModal = true;
      this.driverIndex = index;
      this.clearValidate("xTable");
      this.$refs.driverModel.init();
    },
    chooseDriver(row) {
      //请先维护司机信息
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (row.phoneNum) {
        tableData[this.driverIndex].driverId = row.id;
        tableData[this.driverIndex].driverName = row.realName;
        tableData[this.driverIndex].driverPhone = row.phoneNum;
      } else {
        tableData[this.driverIndex].driverId = null;
        tableData[this.driverIndex].driverName = null;
        tableData[this.driverIndex].driverPhone = null;
        this.$XModal.alert({
          message: "请先维护该司机信息",
          status: "error"
        });
      }

      this.driverModal = false;
    },
    openUser() {
      this.isShowModal = true;
      this.$refs.userModel.init(1);
      this.clearValidate("infotabel");
    },
    chooseUser(row, type) {
      // this.formData[0].sellerName = type === 1 ? row.compName : row.realName;
      this.formData[0].sellerName = row.userName;
      this.isShowModal = false;
    },
    openCarShip(obj, type) {
      this.clearValidate("xTable");
      this.carShipInfo = obj;
      this.carShipVisible = true;
      this.$refs.carShipModal.init(type);
    },
    chooseCarShip(row, type) {
      let data = this.$refs.xTable.getTableData().tableData;
      let i = this.carShipInfo.i;
      if (type === "ship") {
        data[i].carShipNum = row.shipName;
        data[i].carShipId = row.id;
        data[i].transportationType = 2;
      } else {
        data[i].carShipNum = row.carNum;
        data[i].carShipId = row.id;
        data[i].transportationType = 1;
      }
      this.$refs.carShipModal.close();
      this.carShipVisible = false;
    },
    destroyViewer() {
      this.viewer ? this.viewer.destroy() : "";
    },
    handleEditRemove(i) {
      this.$XModal.confirm("您确定要删除该附件吗？").then(type => {
        if (type === "confirm") {
          this.formData[0].appendix.splice(i, 1);
          this.orderPicUUID.splice(i, 1);
        }
      });
    },
    clickFile(url) {
      window.open(url);
    },
    focusEvent(name) {
      let refs = this.$refs[name];
      this.getDicByParentList();
      refs.showPanel();
      this.getChainList();
      this.clearValidate("infotabel");
    },
    getChainList() {
      $api.order.querySupplyChainListModel
        .POST({
          data: {
            page: 1,
            rows: 10
          }
        })
        .then(res => {
          this.chainIdPage.total = res.data.total;
          this.chainIdData = res.data.list;
        });
    },
    getDicByParentList() {
      $api.other.getDicByParentModel
        .GET({
          params: {
            page: 1,
            rows: 10
          }
        })
        .then(res => {
          this.dicByParentData = res.data;
        });
    },
    sellerNameCellClickEvent({ row }) {
      this.formData[0].buyerName = row.dictText;
      this.$refs.sellerDown.hidePanel();
    },
    getBankAccount(obj) {
      this.$refs[`collectionName${obj.rowIndex}`].hidePanel();
      let tableData = this.$refs.xTable.getTableData().fullData;
      tableData[obj.rowIndex].collectionName = obj.accountName;
      tableData[obj.rowIndex].collectionBank = obj.openBankName;
      tableData[obj.rowIndex].collectionAccount = obj.accountNum;
    },
    changeGenerate(obj, i) {
      let tableData = this.$refs.xTable.getTableData().tableData;
      if (obj.ifGenerate === 1) {
        tableData[i].isGenerateNeeded = "必填";
      } else {
        tableData[i].isGenerateNeeded = "选填";
      }
    }
    // getBigPic(i) {
    //   this.lookImageData = [];
    //   if (this.type === 1) {
    //     this.formData[0].appendix.forEach((item, index) => {
    //       let regPdf = /(.pdf)$/i;
    //       if (!regPdf.test(item.oldName)) {
    //         item.name = item.oldName;
    //         item.bigImgUrl = item.url;
    //         this.lookImageData.push(item);
    //         this.showPicIndex = i;
    //         // if (index == i) {
    //         //   this.showPicIndex = this.lookImageData.length - 1;
    //         // }
    //       }
    //     });
    //   }
    //   this.uploadList.forEach((item, index) => {
    //     let regPdf = /(.pdf)$/i;
    //     if (!regPdf.test(item.response.data.oldName)) {
    //       item.name = item.response.data.oldName;
    //       item.bigImgUrl = item.response.data.url;
    //       item.url = item.response.data.url;
    //       // console.log(item, 'abc')
    //       this.lookImageData.push(item);
    //       this.showPicIndex = i;
    //       // if (index == i) {
    //       //   this.showPicIndex = this.lookImageData.length - 1;
    //       // }
    //     }
    //   });
    //   this.isShowPicBox = true;
    // },
  }
};
</script>

<style>
.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}
.add-box .collection-name.vxe-pulldown input::-webkit-input-placeholder {
  color: #ccc;
}
.add-box .collection-name.vxe-pulldown input::-moz-placeholder {
  color: #ccc;
}
.add-box .collection-name.vxe-pulldown input:-ms-input-placeholder {
  color: #ccc;
}
.chainId-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown .ivu-input {
  border-radius: 0;
}
.no-disabled {
  display: block;
  width: 100%;
  height: 56px;
  cursor: not-allowed;
  background-color: #f3f3f3;
}
</style>